// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function open_mouseIn(event, $w) {
	//Add your code for this event here:

	$w('#closed').show() 
	$w('#open').hide()
}


export function closed_mouseOut(event, $w) {
	//Add your code for this event here:

	$w('#open').show() 
	$w('#closed').hide() 
}

export function button13_mouseIn(event) {
	//Add your code for this event here: 
}

export function tipulim1_mouseIn(event) {
	//Add your code for this event here: 

	$w('#tipulim2').show()

}




export function tipulim2_mouseOut(event) {
	//Add your code for this event here:

	$w('#tipulim2').hide() 
}




export function button14_mouseIn(event) {
	//Add your code for this event here: 

	$w('#tipulim2').hide()
}

export function button15_mouseIn(event) {
	//Add your code for this event here: 

	$w('#tipulim2').hide()
}

export function button12_mouseIn(event) {
	//Add your code for this event here:

	$w('#tipulim2').hide() 
}

export function button11_mouseIn(event) {
	//Add your code for this event here: 

	$w('#tipulim2').hide()
}